import React from 'react'
import TreeFilter from '../../../../../../../components/TreeSelectFilter'
import styled from 'styled-components'

const Label = styled.div`
  font-size: 14px;
  color: #000;
  margin-bottom: 8px;
  font-weight: Bold;
`
const LocationFilter = ({  filterOptions, filterValues, handleFilterChange,handleFilterSearch}) => {
  const transformedPreferredLocationList = (filterOptions?.preferredLocationList || [])
  .map(loc => {
    if (loc.city_id && loc.city_name) {
      return {
        id: loc.city_id,
        name: loc.city_name,
      };
    } else if (loc.state_id && loc.state_name) {
      return {
        id: loc.state_id,
        name: loc.state_name,
      };
    } else if (loc.state_name === "Anywhere") {
      return {
        id: "anywhere", // or some fixed ID value
        name: loc.state_name,
      };
    }
    return null;
  })
  .filter(Boolean);

  return (
    <>
      <Label>Permanent Location</Label>
      <div style={{ display:'flex' , rowGap: '0px !important' }}>
      <TreeFilter
        span={12}
        width="95%"
        label="Select State"
        placeholder="Select for the state"
        treeData={filterOptions?.permanentStateList}
        value={filterValues?.selectedPermanentState}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        direction='column'
         valueKey='selectedPermanentState'
      />
      <TreeFilter
        span={11}
        width="100%"
        label="Select City"
        placeholder="Select for the city"
        treeData={filterOptions?.permanentCityList}
        value={filterValues?.selectedPermanentCity}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        direction='column'
         valueKey='selectedPermanentCity'
      />
    </div>
    <Label>Current Location</Label>
    <div style={{ display:'flex' , rowGap: '0px !important' }}>
    <TreeFilter
        span={12}
        width="95%"
        label="Select State"
        placeholder="Select for the state"
        treeData={filterOptions?.currentStateList}
        value={filterValues?.selectedCurrentState}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        direction='column'
         valueKey='selectedCurrentState'
      />
      <TreeFilter
        span={11}
        width="100%"
        label="Select City"
        placeholder="Select for the city"
        treeData={filterOptions?.currentCityList}
        value={filterValues?.selectedCurrentCity}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        direction='column'
         valueKey='selectedCurrentCity'
      />
    </div>
    <Label>Preferred Location</Label>
    <div style={{ display:'flex' , rowGap: '0px !important' }}>
    <TreeFilter
        span={12}
        width="95%"
        label="Select"
        placeholder="Select location"
        treeData={transformedPreferredLocationList}
        value={filterValues?.selectedPreferredLocation}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}
        direction='column'
         valueKey='selectedPreferredLocation'
      />
      
    </div>
    </>

  )
}

export default LocationFilter